import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 28 28\" id=\"icon-add\">  <image id=\"icon-add_image0\" width=\"28\" height=\"28\" x=\"0\" y=\"0\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAACBjSFJN\nAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAb1BMVEX///8kkv8Zkf8akP8a\nkf8akP8Zkf8Zkf8bkv8jl/8akv8akf8akv8ckP8gn/8bkv8ZkP8Zkf8ak/8akP8akf8akf8bkv8c\nk/8akP8akP8ZkP8akf8akP8cnP8akP8ckv8elv8qqv8ckP8ZkP////+tSSKcAAAAI3RSTlMAFcDw\nh4ozq1QWMbt1Lghp/eco65XchUDb+fv1uBKoUiIGU3SSlRoAAAABYktHRACIBR1IAAAAB3RJTUUH\n4wMGAyIeYTQjmgAAAGNJREFUKM/l0EcKgFAMRdFn7733kv3v0Tj4iGDGCt5ZcgaBAFeabpiQsojI\nltBhdP+Jnq8KGEM1RDFbktJzWQ4UJFUClYg10LSd6jzQq2EYpy9+6F2cGRcJQ/7eKuFmjvttcQBa\noBkgMF9/ZAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wMy0wNVQxOTozNDozMCswODowMMy1RFkA\nAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDMtMDVUMTk6MzQ6MzArMDg6MDC96PzlAAAAAElFTkSu\nQmCC\"></image>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add.svg
// module id = 58n+
// module chunks = 10